import React from "react";
import { ClienteProdutoSelecionado } from "../Estilos";
import { useHistory, useLocation } from "react-router-dom";
import { MascaraCNPJ } from "./Funcoes";

function ListaLojasBonificacao({ item }) {
  const history = useHistory();
  return (
    <div>
      <ClienteProdutoSelecionado>
        <div className={"NomeCliente"}>{item.nome}</div>
        <div className={"CNPJSAP"}>
          <span>CPNJ</span> {MascaraCNPJ(item.cnpj)}
        </div>
        <div className={"CNPJSAP"}>
          <span>SAP</span> {item.sap}
        </div>
        <div className={"CNPJSAP2"}>
          <span style={{ width: "70px" }}>Produto:</span>{" "}
          {item.produtoDescricao}
        </div>
        <div className={"CNPJSAP2"}>
          <span style={{ width: "70px" }}>Data:</span>{" "}
          {item.data}
        </div>
        <div
          onClick={() =>
            history.push({
              pathname: "/BonificacaoIntroducao",
              state: { item },
            })
          }
          className={"BtAlterar"}
        >
          RETORNO VENDAS
        </div>
      </ClienteProdutoSelecionado>
    </div>
  );
}

export default ListaLojasBonificacao;
